import { render, staticRenderFns } from "./SystemSelect.vue?vue&type=template&id=32f446ba&scoped=true&"
import script from "./SystemSelect.vue?vue&type=script&lang=js&"
export * from "./SystemSelect.vue?vue&type=script&lang=js&"
import style0 from "./SystemSelect.vue?vue&type=style&index=0&id=32f446ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f446ba",
  null
  
)

export default component.exports